/*
  Logout dialog when access token expire
*/

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

import Button from '@/shared/Button'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const mapStateToProps = ({ auth }) => ({ open: auth.forceLogout })

const LogoutModal = ({ dispatch, open }) => {
  const { t } = useTranslation()

  const onClose = () => {
    localStorage.clear()
    dispatch({ type: 'auth/logout' })
  }

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>{t('general.login_expire')}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2">{t('messages.login_expire')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="neutral" onClick={() => onClose()}>
          {t('general.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mapStateToProps)(LogoutModal)
